import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { SEO_SLUG_CACHE_KEYS } from "./keys";

import { SeoSlugRepository } from "@/repositories/seo-slug";
import { SeoSlugListFilters } from "@/types/seo-slug";

export const useGetAllSeoSlugs = (filters: SeoSlugListFilters) => {
  const seoSlugRepository = useRef(new SeoSlugRepository());

  return useQuery({
    queryKey: [SEO_SLUG_CACHE_KEYS.LIST, filters],
    queryFn: async () => {
      return await seoSlugRepository.current.findAll(filters);
    },
  });
};
